<div class="modal__content">
    <!-- <p class="shipping-account-alert">Click here to agree to the SGC <a href="https://www.gosgc.com/terms" target="_blank">terms and conditions</a>.</p> -->
    <label class="toggle">
        Click here to agree to the SGC <a href="https://www.gosgc.com/terms" target="_blank">terms and conditions</a>.
        <input type="checkbox" [ngModel]="accepted" (ngModelChange)="accept($event)">
        <span class="toggle__check_2"></span>
    </label>
</div>